import React, {createContext, useContext, useEffect, useState} from 'react';
import {useRouteMatch} from "react-router-dom";
import {pathnames as P} from "../../../../common/constants/pathnames";
import {
  getRowsTaxAuthority,
  getRowsFirm,
  getRowsShared,
  getRowsSurveyAssets,
  getRowsTaxAuthorityForExcel,
  getRowsFirmForExcel,
  getRowsSharedForExcel,
  getRowsSurveyAssetsForExcel,
  removeRowTaxAuthority,
  removeRowFirm,
  removeRowShared,
  removeRowSurveyAssets,
  getOriginalRowTaxAuthority,
  getOriginalRowFirm,
  getOriginalRowShared,
  getOriginalRowSurveyAssets,
  editRowTaxAuthority,
  editRowFirm,
  editRowShared,
  editRowSurveyAssets
} from "../../actions/steps/step9SavedRows";
import {getStep9SavedColumns} from '../../actions/steps/getStep9SavedColumns';
import {taxAuthorityColumns, commonColumns, surveyAssetsColumns} from "../../../../common/constants/gridColumns";
import dayjs from "dayjs";
import {convertBinaryToString} from "../../../../common/utils/form/convertBinaryToString";
import {getSalePricePart} from "../../../../common/utils/form/getSalePricePart";
import {formattingPrice} from '../../../../common/utils/formatting';
import {messages as M} from '../../constants/messages';
import {showLittlePopup} from "../../actions/step9LittlePopup";
import {useDispatch} from "react-redux";
import ModalEditRow from '../ModalEditRow';
import ModalViewOriginalRow from '../ModalViewOriginalRow';
import ButtonSelectRow from '../ButtonSelectRow';
import removeIcon from 'common/assets/remove-button.svg';
import {generateExcelFile} from "../../utils/exportToExcel";

const TabSavedRowsContext = createContext('');

export function useTabSavedRowsContext() {
  return useContext(TabSavedRowsContext);
}

export function TabSavedRowsContextProvider({children}) {
  const dispatch = useDispatch();
  const initialData = {
    currentPageNumber: 0,
    gridData: [],
    totalPageCount: 1,
    totalResultCount: 0
  }
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);
  const [loadingTax, setLoadingTax] = useState(false);
  const [loadingFirm, setLoadingFirm] = useState(false);
  const [loadingShared, setLoadingShared] = useState(false);
  const [loadingSurveyAssets, setLoadingSurveyAssets] = useState(false);
  const [taxAuthorityOriginalRow, setTaxAuthorityOriginalRow] = useState({});
  const [taxAuthorityPage, setTaxAuthorityPage] = useState(0);
  const [taxAuthorityData, setTaxAuthorityData] = useState(initialData);
  const [taxAuthorityDataForExcel, setTaxAuthorityDataForExcel] = useState([]);
  const [sortColumnNameTax, setSortColumnNameTax] = useState('');
  const [sortDirectionTax, setSortDirectionTax] = useState('asc');
  const [firmOriginalRow, setFirmOriginalRow] = useState({});
  const [firmPage, setFirmPage] = useState(0);
  const [firmData, setFirmData] = useState(initialData);
  const [firmDataForExcel, setFirmDataForExcel] = useState([]);
  const [sortColumnNameFirm, setSortColumnNameFirm] = useState('');
  const [sortDirectionFirm, setSortDirectionFirm] = useState('asc');
  const [sharedOriginalRow, setSharedOriginalRow] = useState({});
  const [sharedPage, setSharedPage] = useState(0);
  const [sharedData, setSharedData] = useState(initialData);
  const [sharedDataForExcel, setSharedDataForExcel] = useState([]);
  const [sortColumnNameShared, setSortColumnNameShared] = useState('');
  const [sortDirectionShared, setSortDirectionShared] = useState('asc');
  const [surveyAssetsOriginalRow, setSurveyAssetsOriginalRow] = useState({});
  const [surveyAssetsPage, setSurveyAssetsPage] = useState(0);
  const [surveyAssetsData, setSurveyAssetsData] = useState(initialData);
  const [surveyAssetsDataForExcel, setSurveyAssetsDataForExcel] = useState([]);
  const [sortColumnNameSurveyAssets, setSortColumnNameSurveyAssets] = useState('');
  const [sortDirectionSurveyAssets, setSortDirectionSurveyAssets] = useState('asc');

  useEffect(() => {
    dispatch(getStep9SavedColumns({shumaId}));
  }, []);

  const getTaxData = async () => {
    setLoadingTax(true);
    try {
      const result = await getRowsTaxAuthority(shumaId, taxAuthorityPage, sortColumnNameTax, sortDirectionTax);
      setTaxAuthorityData(result);
    } finally {
      setLoadingTax(false)
    }
  };
  const getFirmData = async () => {
    setLoadingFirm(true);
    try {
      const result = await getRowsFirm(shumaId, firmPage, sortColumnNameFirm, sortDirectionFirm);
      setFirmData(result);
    } finally {
      setLoadingFirm(false)
    }
  };
  const getSharedData = async () => {
    setLoadingShared(true);
    try {
      const result = await getRowsShared(shumaId, sharedPage, sortColumnNameShared, sortDirectionShared);
      setSharedData(result);
    } finally {
      setLoadingShared(false)
    }
  };
  const getSurveyAssetsData = async () => {
    setLoadingSurveyAssets(true);
    try {
      const result = await getRowsSurveyAssets(shumaId, surveyAssetsPage, sortColumnNameSurveyAssets, sortDirectionSurveyAssets);
      setSurveyAssetsData(result);
    } finally {
      setLoadingSurveyAssets(false)
    }
  };

  useEffect(() => {
    getTaxData();
  }, [taxAuthorityPage]);
  useEffect(() => {
    getFirmData();
  }, [firmPage]);
  useEffect(() => {
    getSharedData();
  }, [sharedPage]);
  useEffect(() => {
    getSurveyAssetsData();
  }, [surveyAssetsPage]);

  const getTaxAuthorityDataForExcel = async () => {
    const result = await getRowsTaxAuthorityForExcel(shumaId, sortColumnNameTax, sortDirectionTax);
    setTaxAuthorityDataForExcel(result);
  };
  const getFirmDataForExcel = async () => {
    const result = await getRowsFirmForExcel(shumaId, sortColumnNameFirm, sortDirectionFirm);
    setFirmDataForExcel(result)
  };
  const getSharedDataForExcel = async () => {
    const result = await getRowsSharedForExcel(shumaId, sortColumnNameShared, sortDirectionShared);
    setSharedDataForExcel(result)
  };
  const getSurveyAssetsDataForExcel = async () => {
    const result = await getRowsSurveyAssetsForExcel(shumaId, sortColumnNameSurveyAssets, sortDirectionSurveyAssets);
    setSurveyAssetsDataForExcel(result)
  };

  const onGetRowTax = (id) => getOriginalRowTaxAuthority(shumaId, id).then(setTaxAuthorityOriginalRow);
  const onGetRowFirm = (id) => getOriginalRowFirm(shumaId, id).then(setFirmOriginalRow);
  const onGetRowShared = (id) => getOriginalRowShared(shumaId, id).then(setSharedOriginalRow);
  const onGetRowSurveyAssets = (id) => getOriginalRowSurveyAssets(shumaId, id).then(setSurveyAssetsOriginalRow);

  const onEditRowTax = async (values) => {
    const data = {
      ...values,
      shumaId,
      id: values?.id ?? 0,
      saleDate: values?.saleDate ? dayjs(values.saleDate).format('YYYY-MM-DD') : '',
      salePrice: values?.salePrice ? Number(values?.salePrice.replace(/,/g, '')) : '',
      estimatePrice: values?.estimatePrice ? Number(values?.estimatePrice.replace(/,/g, '')) : '',
      city: values?.city?.label ?? '',
      street: values?.street?.label ?? '',
    }
    const result = await editRowTaxAuthority(shumaId, data);
    if (result.data.errorCode < 0) {
      dispatch(showLittlePopup(M.FAILED));
    }
    await getTaxData();
  };
  const onEditRowFirm = async (values) => {
    const data = {
      ...values,
      shumaId,
      id: values?.id ?? 0,
      officialDate: values?.officialDate ? dayjs(values.officialDate).format('YYYY-MM-DD') : '',
      cityName: values?.cityName?.label ?? '',
      streetName: values?.streetName?.label ?? '',
      houseParking: values?.houseParking?.value ?? 0,
      houseStorage: values?.houseStorage?.value ?? 0,
      houseRoof: values?.houseRoof?.value ?? 0,
      houseYard: values?.houseYard?.value ?? 0,
      buildingElevator: values?.buildingElevator?.value ?? 0,
      estimatePriceFinal: values?.estimatePriceFinal ? parseFloat(values.estimatePriceFinal) : 0
    }
    const result = await editRowFirm(shumaId, data);
    if (result.data.errorCode < 0) {
      dispatch(showLittlePopup(M.FAILED));
    }
    await getFirmData();
  };
  const onEditRowShared = async (values) => {
    const data = {
      ...values,
      shumaId,
      id: values?.id ?? 0,
      officialDate: values?.officialDate ? dayjs(values.officialDate).format('YYYY-MM-DD') : '',
      cityName: values?.cityName?.label ?? '',
      streetName: values?.streetName?.label ?? '',
      houseParking: values?.houseParking?.value ?? 0,
      houseStorage: values?.houseStorage?.value ?? 0,
      houseRoof: values?.houseRoof?.value ?? 0,
      houseYard: values?.houseYard?.value ?? 0,
      buildingElevator: values?.buildingElevator?.value ?? 0,
    }
    const result = await editRowShared(shumaId, data);
    if (result.data.errorCode < 0) {
      dispatch(showLittlePopup(M.FAILED));
    }
    await getSharedData();
  };
  const onEditRowSurveyAssets = async (values) => {
    const data = {
      ...values,
      cityID: values?.cityID?.value ?? 0,
      streetID: values?.streetID?.value ?? 0,
      houseParking: values?.houseParking?.value ?? 0,
      houseStorage: values?.houseStorage?.value ?? 0,
      houseRoof: values?.houseRoof?.value ?? 0,
      houseYard: values?.houseYard?.value ?? 0,
      buildingElevator: values?.buildingElevator?.value ?? 0,
      houseBalconyCount: values?.houseBalconyCount ? parseInt(values.houseBalconyCount) : 0
    }
    const result = await editRowSurveyAssets(shumaId, data);
    if (result.data.errorCode < 0) {
      dispatch(showLittlePopup(M.FAILED));
    }
    await getSurveyAssetsData();
  };

  const mapGrid = (gridName) => item => {
    const {
      price,
      askingPrice,
      estimatePriceFinal,
      ...restValues
    } = item;
    const formattedPrice = price ? formattingPrice(parseInt(price, 10)) : '';
    const formattedAskingPrice = askingPrice ? formattingPrice(parseInt(askingPrice, 10)) : '';
    switch (gridName) {
      case 'tax':
        const onRemoveRowTax = () => {
          removeRowTaxAuthority(shumaId, item.id)
            .then(() => dispatch(showLittlePopup(M.GRID_ROW_REMOVED)))
            .then(() => getTaxData())
        };
        return {
          ...restValues,
          checked: <ButtonSelectRow action={onRemoveRowTax} icon={removeIcon}/>,
          areaRooms: item?.netAreaInSquareMeters && item?.roomCount
            ? (item?.netAreaInSquareMeters / item?.roomCount).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
            : '',
          salePriceSoldShare: item?.salePrice && item?.soldShare
            ? (Number(item?.salePrice.replace(/,/g, "")) * getSalePricePart(item?.soldShare)).toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            })
            : '',
          edit: [
            <ModalEditRow gridName={'tax'} onEdit={onEditRowTax} {...item}/>,
            <ModalViewOriginalRow
              originID={item?.id}
              gridName={'tax'}
              getOriginal={onGetRowTax}
              row={taxAuthorityOriginalRow?.originData}
              {...item}
            />
          ]
        }
      case 'surveyAssets':
        const onRemoveRowSurveyAssets = () => {
          removeRowSurveyAssets(shumaId, item.id)
            .then(() => dispatch(showLittlePopup(M.GRID_ROW_REMOVED)))
            .then(() => getSurveyAssetsData())
        };
        return {
          ...restValues,
          checked: <ButtonSelectRow action={onRemoveRowSurveyAssets} icon={removeIcon}/>,
          askingPrice: formattedAskingPrice,
          edit: [
            <ModalEditRow gridName={'surveyAssets'} onEdit={onEditRowSurveyAssets} {...item}/>,
            <ModalViewOriginalRow
              originID={item?.id}
              gridName={'surveyAssets'}
              getOriginal={onGetRowSurveyAssets}
              row={surveyAssetsOriginalRow?.originData}
              {...item}
            />
          ]
        }
      case 'firm':
        const onRemoveRowFirm = () => {
          removeRowFirm(shumaId, item.id)
            .then(() => dispatch(showLittlePopup(M.GRID_ROW_REMOVED)))
            .then(() => getFirmData())
        };
        return {
          checked: <ButtonSelectRow action={onRemoveRowFirm} icon={removeIcon}/>,
          price: formattedPrice || estimatePriceFinal,
          ...restValues,
          edit: [
            <ModalEditRow gridName={'firm'} onEdit={onEditRowFirm} {...item}/>,
            <ModalViewOriginalRow
              originID={item?.id}
              gridName={'firm'}
              getOriginal={onGetRowFirm}
              row={firmOriginalRow?.originData}
              {...item}
            />
          ]
        };
      case 'shared':
      default:
        const onRemoveRowShared = () => {
          removeRowShared(shumaId, item.id)
            .then(() => dispatch(showLittlePopup(M.GRID_ROW_REMOVED)))
            .then(() => getSharedData())
        };
        return {
          ...restValues,
          checked: <ButtonSelectRow action={onRemoveRowShared} icon={removeIcon}/>,
          price: formattedPrice || estimatePriceFinal,
          edit: [
            <ModalEditRow gridName={'shared'} onEdit={onEditRowShared} {...item}/>,
            <ModalViewOriginalRow
              originID={item?.id}
              gridName={'shared'}
              getOriginal={onGetRowShared}
              row={sharedOriginalRow?.originData}
              {...item}
            />
          ]
        };
    }
  };

  const preparedGridTaxAuthority = taxAuthorityData?.gridData
    ? taxAuthorityData.gridData.map(mapGrid('tax')) : [];
  const preparedGridFirm = firmData?.gridData
    ? firmData.gridData.map(mapGrid('firm')) : [];
  const preparedGridShared = sharedData?.gridData
    ? sharedData.gridData.map(mapGrid('shared')) : [];
  const preparedGridSurveyAssets = surveyAssetsData?.gridData
    ? surveyAssetsData.gridData.map(mapGrid('surveyAssets')) : [];
  const preparedGridTaxAuthorityForExcel = Array.isArray(taxAuthorityDataForExcel?.gridData)
    ? taxAuthorityDataForExcel.gridData.map((item, index) => {
      const headersForExcel = taxAuthorityColumns.map(item => item.Header);
      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: item?.gushHelkaTtHelka,
        [headersForExcel[2]]: item?.saleDate ? dayjs(item.saleDate).format('DD-MM-YYYY') : '',
        [headersForExcel[3]]: item?.city,
        [headersForExcel[4]]: item?.street,
        [headersForExcel[5]]: item?.houseNumber,
        [headersForExcel[6]]: item?.entranceNumber,
        [headersForExcel[7]]: item?.apartmentNumber,
        [headersForExcel[8]]: item?.salePrice,
        [headersForExcel[9]]: item?.estimatePrice,
        [headersForExcel[10]]: item?.brutoAreaType,
        [headersForExcel[11]]: item?.brutoAreaInSquareMeters,
        [headersForExcel[12]]: item?.netAreaType,
        [headersForExcel[13]]: item?.netAreaInSquareMeters,
        [headersForExcel[14]]: item?.buildYear,
        [headersForExcel[15]]: item?.pricePerRoom,
        [headersForExcel[16]]: item?.pricePerSquareMeter,
        [headersForExcel[17]]: item?.roomCount,
        [headersForExcel[18]]: item?.floor,
        [headersForExcel[19]]: item?.floorsCount,
        [headersForExcel[20]]: item?.roomsCount,
        [headersForExcel[21]]: item?.parking,
        [headersForExcel[22]]: item?.elevator,
        [headersForExcel[23]]: item?.roof,
        [headersForExcel[24]]: item?.storage,
        [headersForExcel[25]]: item?.yard,
        [headersForExcel[26]]: item?.lot,
        [headersForExcel[27]]: item?.gallery,
        [headersForExcel[28]]: item?.sellType,
        [headersForExcel[29]]: item?.propertyType,
        [headersForExcel[30]]: item?.soldShare,
        [headersForExcel[31]]: item?.essenseOfRight,
        [headersForExcel[32]]: item?.buildingUnitFunction,
        [headersForExcel[33]]: item?.netAreaInSquareMeters && item?.roomCount
          ? (item?.netAreaInSquareMeters / item?.roomCount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
          : '',
        [headersForExcel[34]]: item?.salePrice && item?.soldShare
          ? (Number(item?.salePrice.replace(/,/g, "")) * getSalePricePart(item?.soldShare)).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          })
          : ''
      }
    })
    : [];
  const preparedGridFirmForExcel = Array.isArray(firmDataForExcel?.gridData)
    ? firmDataForExcel.gridData.map((item, index) => {
      const headersForExcel = commonColumns.map(item => item.Header);
      const formattedPrice = item?.price || item?.estimatePriceFinal;
      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: Boolean(item?.officialDate)
          ? dayjs(item?.officialDate).format('DD-MM-YYYY')
          : '',
        [headersForExcel[2]]: item?.gush,
        [headersForExcel[3]]: item?.helka,
        [headersForExcel[4]]: item?.cityName,
        [headersForExcel[5]]: item?.streetName,
        [headersForExcel[6]]: item?.houseNum,
        [headersForExcel[7]]: item?.houseRegisteredArea,
        [headersForExcel[8]]: item?.houseRoomCount,
        [headersForExcel[9]]: item?.floor,
        [headersForExcel[10]]: item?.buildingFloorsCount,
        [headersForExcel[11]]: item?.buildingAge,
        [headersForExcel[12]]: convertBinaryToString(item?.houseParking),
        [headersForExcel[13]]: convertBinaryToString(item?.buildingElevator),
        [headersForExcel[14]]: convertBinaryToString(item?.houseYard),
        [headersForExcel[15]]: convertBinaryToString(item?.houseStorage),
        [headersForExcel[16]]: convertBinaryToString(item?.houseRoof),
        [headersForExcel[17]]: item?.registeredArea,
        [headersForExcel[18]]: formattedPrice,
      }
    })
    : [];
  const preparedGridSharedForExcel = Array.isArray(sharedDataForExcel?.gridData)
    ? sharedDataForExcel.gridData.map((item, index) => {
      const headersForExcel = commonColumns.map(item => item.Header);
      const formattedPrice = item?.price || item?.estimatePriceFinal;
      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: Boolean(item?.officialDate)
          ? dayjs(item?.officialDate).format('DD-MM-YYYY')
          : '',
        [headersForExcel[2]]: item?.gush,
        [headersForExcel[3]]: item?.helka,
        [headersForExcel[4]]: item?.cityName,
        [headersForExcel[5]]: item?.streetName,
        [headersForExcel[6]]: item?.houseNum,
        [headersForExcel[7]]: item?.houseRegisteredArea,
        [headersForExcel[8]]: item?.houseRoomCount,
        [headersForExcel[9]]: item?.floor,
        [headersForExcel[10]]: item?.buildingFloorsCount,
        [headersForExcel[11]]: item?.buildingAge,
        [headersForExcel[12]]: convertBinaryToString(item?.houseParking),
        [headersForExcel[13]]: convertBinaryToString(item?.buildingElevator),
        [headersForExcel[14]]: convertBinaryToString(item?.houseYard),
        [headersForExcel[15]]: convertBinaryToString(item?.houseStorage),
        [headersForExcel[16]]: convertBinaryToString(item?.houseRoof),
        [headersForExcel[17]]: item?.registeredArea,
        [headersForExcel[18]]: formattedPrice,
      }
    })
    : [];
  const preparedGridSurveyAssetsForExcel = Array.isArray(surveyAssetsDataForExcel?.gridData)
    ? surveyAssetsDataForExcel?.gridData.map((item, index) => {
      const headersForExcel = surveyAssetsColumns.map(item => item.Header);
      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: item?.cityName,
        [headersForExcel[2]]: item?.streetName,
        [headersForExcel[3]]: item?.houseNum,
        [headersForExcel[4]]: item?.houseRegisteredArea,
        [headersForExcel[5]]: item?.houseRoomCount,
        [headersForExcel[6]]: item?.floor,
        [headersForExcel[7]]: item?.buildingFloorsCount,
        [headersForExcel[8]]: item?.buildYear,
        [headersForExcel[9]]: convertBinaryToString(item?.houseParking),
        [headersForExcel[10]]: convertBinaryToString(item?.buildingElevator),
        [headersForExcel[11]]: convertBinaryToString(item?.houseYard),
        [headersForExcel[12]]: convertBinaryToString(item?.houseStorage),
        [headersForExcel[13]]: convertBinaryToString(item?.houseRoof),
        [headersForExcel[14]]: item?.houseBalconyCount,
        [headersForExcel[15]]: item?.askingPrice
          ? parseInt(item?.askingPrice).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
          : '',
        [headersForExcel[16]]: item?.marketingFactor,
      }
    })
    : [];

  const handleSortChangeTax = (column, direction) => {
    setLoadingTax(true);
    setSortColumnNameTax(column);
    setSortDirectionTax(direction);
    getRowsTaxAuthority(shumaId, taxAuthorityPage, column, direction)
      .then(setTaxAuthorityData).finally(() => setLoadingTax(false));
  };
  const handleSortChangeFirm = (column, direction) => {
    setLoadingFirm(true);
    setSortColumnNameFirm(column);
    setSortDirectionFirm(direction);
    getRowsFirm(shumaId, firmPage, column, direction)
      .then(setFirmData).finally(() => setLoadingFirm(false));
  };
  const handleSortChangeShared = (column, direction) => {
    setLoadingShared(true);
    setSortColumnNameShared(column);
    setSortDirectionShared(direction);
    getRowsShared(shumaId, sharedPage, column, direction)
      .then(setSharedData).finally(() => setLoadingShared(false));
  };
  const handleSortChangeSurveyAssets = (column, direction) => {
    setLoadingSurveyAssets(true);
    setSortColumnNameSurveyAssets(column);
    setSortDirectionSurveyAssets(direction);
    getRowsSurveyAssets(shumaId, surveyAssetsPage, column, direction)
      .then(setSurveyAssetsData).finally(() => setLoadingSurveyAssets(false));
  };

  const handleGetExcel = async () => {
    await getTaxAuthorityDataForExcel();
    await getFirmDataForExcel();
    await getSharedDataForExcel();
    await getSurveyAssetsDataForExcel();
    generateExcelFile([
      {data: preparedGridTaxAuthorityForExcel},
      {data: preparedGridFirmForExcel},
      {data: preparedGridSharedForExcel},
      {data: preparedGridSurveyAssetsForExcel},
    ].filter(item => item.data.length > 0), 'נכסים שנבחרו.xlsx')
  };

  return (
    <TabSavedRowsContext.Provider value={{
      preparedGridTaxAuthority,
      totalPagesTaxAuthority: taxAuthorityData?.totalPageCount ?? 0,
      totalResultCountTaxAuthority: taxAuthorityData?.totalResultCount ?? 0,
      setTaxAuthorityPage,
      taxAuthorityPage,
      sortColumnNameTax,
      sortDirectionTax,
      handleSortChangeTax,

      preparedGridFirm,
      totalPagesFirm: firmData?.totalPageCount ?? 0,
      totalResultCountFirm: firmData?.totalResultCount ?? 0,
      setFirmPage,
      firmPage,
      sortColumnNameFirm,
      sortDirectionFirm,
      handleSortChangeFirm,

      preparedGridShared,
      totalPagesShared: sharedData?.totalPageCount ?? 0,
      totalResultCountShared: sharedData?.totalResultCount ?? 0,
      setSharedPage,
      sharedPage,
      sortColumnNameShared,
      sortDirectionShared,
      handleSortChangeShared,

      preparedGridSurveyAssets,
      totalPagesSurveyAssets: surveyAssetsData?.totalPageCount ?? 0,
      totalResultCountSurveyAssets: surveyAssetsData?.totalResultCount ?? 0,
      setSurveyAssetsPage,
      surveyAssetsPage,
      sortColumnNameSurveyAssets,
      sortDirectionSurveyAssets,
      handleSortChangeSurveyAssets,

      handleGetExcel,
      loading: loadingTax || loadingFirm || loadingShared || loadingSurveyAssets
    }}>
      {children}
    </TabSavedRowsContext.Provider>
  );
}